import { motion } from 'framer-motion';
import SectionHeading from './SectionHeading';
import { sectors } from '@/lib/siteData';

const Sectors = () => {
  return (
    <section className="bg-slate-50 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          center
          eyebrow="Sectores que atendemos"
          title={
            <>
              LIMPIAMOS LOS ESPACIOS
              <br />
              DONDE TU EMPRESA CRECE
            </>
          }
        />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {sectors.map(([title, image], index) => (
            <motion.article
              key={title}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className={`group relative overflow-hidden ${
                index === 0 || index === 7 ? 'lg:col-span-2' : ''
              }`}
            >
              <img
                src={image}
                alt={`Limpieza profesional en ${title.toLowerCase()}`}
                className="h-64 w-full object-cover transition duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A2540]/95 via-[#0A2540]/25 to-transparent" />
              <h3 className="absolute bottom-0 p-5 text-sm font-bold uppercase tracking-wide text-white">
                {title}
              </h3>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sectors;